import Loader from 'react-loaders'

let Loading = () => {
    return (
        <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
            <Loader type="line-scale-party" />
        </div>)
}

export default Loading